// @ts-strict-ignore
import { useMediaQuery } from 'react-responsive'

import dayjs from 'dayjs'
import Image from 'next/image'

import { mediaQueryIsMobile } from '~/theme/utils/grid'
import { getSlotFromTime } from '~/utils/graphqlDataFormatters'

import ListingPage from '~/components/Listing/ListingPageContent'
import { useListingQuery } from '~/components/Listing/ListingPageContent/ListingPageContentUtils'
import ReservationOfferCard from '~/components/Reservation/ReservationOfferCard'
import { isDemo } from '~/config/clubConfig'
import { ReservableExtraListQuery, useAllTagsQuery, useClientConfigQuery, useReservableExtraListQuery } from '~/generated/graphql'
import { gt } from '~/locale'
import { NextPageWithLayout } from '~/pages/_app'
import { useLocation } from '~/shared/molecules/LocationMenu/LocationMenuUtils'

import { chefsMenuDefaultFilterSettings, getReservableExtraListQueryVariables, PAGE_SIZE } from './ChefsMenuListingPageUtils'

interface Props {
  availableDatesISOString: string[]
  minDateISOString?: string
  data: ReservableExtraListQuery
}

const ChefsMenuListingPage: NextPageWithLayout<Props> = () => {
  const { loading, fetchMore, setFilters, filters, isFetchingMore, data } = useListingQuery({
    getQueryVariables: getReservableExtraListQueryVariables,
    useQueryHook: useReservableExtraListQuery,
    pageSize: PAGE_SIZE,
  })
  const items = data?.reservableExtras.nodes

  const { data: tagsData } = useAllTagsQuery({ fetchPolicy: 'cache-first', variables: { regionId: filters.selectedRegion.id } })
  const tags = tagsData?.tags || []

  const { tp } = gt

  const { data: clientConfig } = useClientConfigQuery()
  const reservableFrom = dayjs.parseZone(clientConfig?.clientConfigs.reservableExtraDefaultReservableFrom)

  const isMobile = useMediaQuery({ query: mediaQueryIsMobile })
  const { regions } = useLocation()

  // This is only for quick demo purposes - should be deleted as soon as possible
  let topBanner = <></>
  if (!isDemo) {
    if (isMobile) {
      topBanner = (
        <Image
          src='/assets/listing/chefsMenuBannerMobile.png'
          alt={tp('ChefsMenuPage', 'Odkrywaj nowe restauracje poprzez popisowe menu chefów')}
          width={414}
          height={247}
          priority={true}
        />
      )
    } else {
      topBanner = (
        <Image
          src='/assets/listing/chefsMenuBannerDesktop.png'
          alt={tp('ChefsMenuPage', 'Odkrywaj nowe restauracje poprzez popisowe menu chefów')}
          width={1440}
          height={320}
          priority={true}
        />
      )
    }
  }

  return (
    <ListingPage
      type='chefsmenu'
      isLoading={!data && loading}
      isFetchingMore={isFetchingMore}
      defaultDate={reservableFrom}
      defaultSlot={getSlotFromTime(reservableFrom)}
      topBanner={topBanner}
      listingBanner={() => null}
      items={items || []}
      renderItem={item => {
        return <ReservationOfferCard key={item.id} reservableExtra={item} type='regular' />
      }}
      totalCount={data?.reservableExtras.totalCount}
      regions={regions}
      defaultFilterSettings={chefsMenuDefaultFilterSettings}
      filterSections={['cuisines', 'dishes', 'other']}
      fetchMore={() => fetchMore({ variables: { after: items.length.toString() } })}
      onFiltersChange={setFilters}
      allTags={tags}
      showExtraGuest
    />
  )
}

export default ChefsMenuListingPage
